




























import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WMenu extends BaseComponent {
	@Prop({ type: Array, required: true })
	menus!: Array<any>;
	popin = true;

	mounted() {
		let x = this;
		setTimeout(() => {
			x.popin = false;
		}, 1500);
	}
}
